export default function IlluminationPolicy() {
    return (
        <div className="flex flex-col items-center justify-center px-6 py-6 bg-gray-100 rounded-lg text-gray-900">
            <div className="max-w-3xl text-center bg-white p-8 rounded-lg shadow-lg">
                <h1 className="text-3xl font-bold mb-6">Illumination Policy</h1>
                <p className="text-lg leading-relaxed">
                    As Arkenom Teknoloji, we process your personal data for the following purposes:
                </p>
                <ul className="mt-4 text-lg leading-relaxed text-left list-disc list-inside">
                    <li>Providing and improving our services</li>
                    <li>Fulfilling legal obligations</li>
                    <li>Conducting communication activities</li>
                </ul>
                <p className="mt-4 text-lg leading-relaxed">
                    Your personal data can be corrected, deleted, or anonymized upon request, in accordance with 
                    Article 11 of the Personal Data Protection Law (KVKK).
                </p>
            </div>
        </div>
    );
}
